<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('wdcsdd')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="toptj" v-loading="homeLoading">
                <div class="tjitem" >
                    <span>{{$t('zczds')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callNum}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('jrchds')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recall}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('jrchl')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallRate}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('zcje')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callMoney}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('chje')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallMoney}}</i>
                    </div>
                </div>
            </div>
            <div class="search">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item :label="$t('phone')">
                            <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('mchOrderNo')">
                            <el-input v-model="searchform.mchOrderNo" @keyup.enter.native="onSubmit" size="small"></el-input>
                        </el-form-item>
                        <el-form-item v-if="this.user.user.roles[0].id != 3" :label="$t('csy')">
                            <el-select size="small" v-model="searchform.principalId" style="width:150px;" :placeholder="$t('qxzcsymc')"  >
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option v-for="(item,index) in principallist1" :label="item.nickName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="this.user.user.roles[0].id != 3" :label="$t('bookName')">
                            <el-select size="small" v-model="searchform.accountId" style="width:180px;" :placeholder="$t('pleaseZhangqi')"  >
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option v-for="(item,index) in accountlist" :label="item.bookName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('type')">
                            <el-select v-model="searchform.statusValue" style="width:120px;">
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option :label="$t('loan4')" :value="0"></el-option>
                                <el-option :label="$t('loan5')" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item :label="$t('time')">
                            <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            size="small"
                            range-separator="至"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
                            </el-date-picker>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <el-table :data="list" highlight-current-row @current-change="handleCurrentChange"  
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="mchOrderNo" :label="$t('mchOrderNo')"></el-table-column>
                        <!-- <el-table-column prop="stats" :label="$t('stats')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.stats=='已还'" type="info">{{$t('yhk')}}</el-tag>
                                <el-tag v-if="scope.row.stats=='未还'" type="info">{{$t('whk')}}</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="overdueDay" :label="$t('overdueDay')"></el-table-column>
                        <!-- <el-table-column prop="expireTime" :label="$t('expireTime')"></el-table-column> -->
                        <!-- <el-table-column prop="level" :label="$t('ckrq')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column prop="days" :label="$t('days')"></el-table-column> -->
                        <el-table-column prop="cantidad" :label="$t('cantidad')"></el-table-column>
                        <!-- <el-table-column prop="userName" :label="$t('userName')"></el-table-column> -->

                        <el-table-column prop="phone" :label="$t('phone')">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="dial(scope.row.phone,0)">
                                    {{scope.row.phone}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="email" :label="$t('email')"></el-table-column> -->
                        <!-- <el-table-column prop="exclusiveLinks" :label="$t('exclusiveLinks)'"></el-table-column> -->
                        <el-table-column sortable prop="callNum" :label="$t('callnum')" width="88px"></el-table-column>
                        <!-- <el-table-column prop="platform" :label="$t('pingt')"></el-table-column> -->
                        <!-- <el-table-column prop="agingDetail" :label="$t('fqcs')" width="118px"></el-table-column> -->
                        <el-table-column prop="statusValue" :label="$t('status')" width="100">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.statusValue == 0" type="info">{{$t('loan4')}}</el-tag>
                                <el-tag v-if="scope.row.statusValue == 1" type="info">{{$t('loan5')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="70" fixed="right">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top">
                                     <el-button size="small" @click="openadd(scope.row)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
                <div class="listleft">
                    <el-tabs type="border-card">
                        <el-tab-pane :label="$t('jbxx')">
                            <div class="orderdiv">
                                <div class="formbox" @submit.prevent style="width:750px;">
                                    <h2 style="margin-bottom:12px;">{{$t('ddxq')}}</h2>
                                    <el-form ref="form" :model="orderForm" label-width="160px">
                                        <el-form-item :label="$t('phone')">
                                            <el-input v-model="orderForm.phone" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('email')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.email" style="width:160px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('userName')" stle="margin-left: 260px;margin-top: -60px;">
                                            <el-input v-model="orderForm.userName" style="width:160px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('mchOrderNo')">
                                            <el-input v-model="orderForm.mchOrderNo" style="width:140px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('upProductName')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.upProductName" style="width:140px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('cantidad')">
                                            <el-input v-model="orderForm.cantidad" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('days')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.days" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('dkje')">
                                            <el-input v-model="orderForm.outMoney" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('expireTime')" style="margin-left: 300px;margin-top: -60px;">
                                            <el-input v-model="orderForm.expireTime" style="widthy:130px;" :disabled="true" ></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('stats')">
                                            <el-input v-model="orderForm.stats" style="width:130px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('exclusiveLinks')" style="margin-left: 260px;margin-top: -60px;">
                                            <el-input v-model="orderForm.exclusiveLinks" style="width:130px;" :disabled="true"></el-input>
                                            <button style="margin-left:6px" @click="copyContent(orderForm.exclusiveLinks)">复制链接</button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                            <!-- <div class="orderdiv" style="margin-top: 8px;">
                                <div class="formbox" style="width:750px;">
                                    <h2 style="margin-bottom:10px;">基本信息</h2>
                                    <el-form ref="form" :model="form" label-width="130px">
                                        <el-form-item label="姓名">
                                            <el-input v-model="form.fullName" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="父姓" style="margin-left: 300px;margin-top: -62px;">
                                            <el-input v-model="form.fatherLastName" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="母姓">
                                            <el-input v-model="form.motherLastName" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="身份证号码" style="margin-left: 300px;margin-top: -62px;">
                                            <el-input v-model="form.idNumber" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="性别">
                                            <el-input v-model="form.gender" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮箱" style="margin-left: 300px;margin-top: -62px;">
                                            <el-input v-model="form.email" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="生日">
                                            <el-input v-model="form.birthday" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮政编码" style="margin-left: 300px;margin-top: -62px;">
                                            <el-input v-model="form.postalCode" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="地区">
                                            <el-input v-model="form.district" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                        <el-form-item label="地址" style="margin-left: 300px;margin-top: -62px;">
                                            <el-input v-model="form.addressAll" style="width:200px;" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div> -->
                            <div class="orderdiv" style="margin-top: 8px;">
                                <el-tabs type="border-card">
                                    <el-tab-pane :label="$t('gzxx')">
                                        <div class="formbox" style="width:750px;">
                                            <el-form ref="form" :model="form" label-width="180px">
                                               <el-form-item :label="$t('educationName')">
                                                    <el-input v-model="form.educationName" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('employmentName')" style="margin-left: 320px;margin-top: -62px;">
                                                    <el-input v-model="form.employmentName" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('comoanyName')">
                                                    <el-input v-model="form.comoanyName" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('comoanyPhone')" style="margin-left: 340px;margin-top: -62px;">
                                                    <el-input v-model="form.comoanyPhone" style="width:160px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('workingYearName')">
                                                    <el-input v-model="form.workingYearName" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('monthlySalaryName')" style="margin-left: 320px;margin-top: -62px;">
                                                    <el-input v-model="form.monthlySalaryName" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item label="WhatsApp">
                                                    <el-input v-model="form.whatsApp" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item label="Facebook" style="margin-left: 320px;margin-top: -62px;">
                                                    <el-input v-model="form.facebook" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('workingDaysName')">
                                                    <el-input v-model="form.workingDaysName" style="width:130px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                
                                            </el-form>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane :label="$t('jjlxr')">
                                        <div class="formbox" style="width:750px;">
                                            <el-form ref="form" :model="contactform" label-width="170px">
                                                <el-form-item :label="$t('lxr1xm')">
                                                    <el-input v-model="contactform.oneName" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr2xm')" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.twoName" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr1dh')">
                                                    <el-input v-model="contactform.onePhone" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr2dh')" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.twoPhone" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr1gx')">
                                                    <el-input v-model="contactform.oneType" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr2gx')" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.twoType" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>

                                                <el-form-item :label="$t('lxr3xm')" v-if="contactform.threeName != null">
                                                    <el-input v-model="contactform.threeName" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr4xm')" v-if="contactform.foruName != null" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.foruName" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr3dh')" v-if="contactform.threePhone != null">
                                                    <el-input v-model="contactform.threePhone" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>

                                                <el-form-item :label="$t('lxr4dh')" v-if="contactform.foruPhone != null" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.foruPhone" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr3gx')" v-if="contactform.threeType != null">
                                                    <el-input v-model="contactform.threeType" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="$t('lxr4gx')" v-if="contactform.foruType != null" style="margin-left: 360px;margin-top: -62px;">
                                                    <el-input v-model="contactform.foruType" style="width:200px;" :disabled="true"></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </el-tab-pane>
                                    <!-- <el-tab-pane label="借贷历史">
                                        <div class="formbox" style="width:750px;" v-loading="loanLoading">
                                            <el-table :data="loanList"
                                                :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                                <el-table-column prop="level" label="借款时间">
                                                    <template slot-scope="scope">
                                                        {{scope.row.createTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="mchOrderNo" label="订单号"></el-table-column>
                                                <el-table-column prop="cuenta" label="银行卡号"></el-table-column>
                                                <el-table-column prop="cantidad" label="申请金额"></el-table-column>
                                                <el-table-column prop="days" label="申请期限"></el-table-column>
                                                <el-table-column prop="stats" label="订单状态"></el-table-column>
                                            </el-table>
                                            <div class="page">
                                                <app-page :total="loanTotal" :current="loanPageNo" :pageSize="loanPageSize"
                                                    @handleCurrentChange="loanCurrentchange" @handleSizeChange="loanHandchange"></app-page>
                                            </div>
                                        </div>
                                    </el-tab-pane> -->
                                </el-tabs>
                            </div>
                            <div class="orderdiv" style="margin-top: 8px;">
                                <div class="formbox" style="width:750px;">
                                    <h2 style="margin-bottom:10px;">{{$t('sfxx')}}</h2>
                                    <el-form ref="form" :model="form" label-width="130px">
                                        <el-form-item :label="$t('idCardPositive')">
                                            <div class="block">
                                                <el-image :src="form.idCardPositive">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :label="$t('idCardReverse')">
                                            <div class="block">
                                                <el-image :src="form.idCardReverse">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :label="$t('faceUrl')">
                                            <div class="block">
                                                <el-image :src="form.faceUrl">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('txl')">
                            <div class="search">
                                <el-form :inline="true" :model="searchform1" class="demo-form-inline" @submit.native.prevent >
                                    <el-form-item :label="$t('phone')">
                                        <el-input v-model="searchform1.phone" style="width: 150px;" @keyup.enter.native="txlonSubmit" size="small"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="small" type="primary" @click="txlonSubmit">{{$t('query')}}</el-button>
                                    </el-form-item>
                                    <el-button type="success" v-if="this.cardFirst != null" @click="cf">Qaa1：{{cardFirst}}</el-button>
                                    <el-button type="success" v-if="this.cardSecond != null" @click="cs">Qaa2：{{cardSecond}}</el-button>
                                    <el-button type="primary">{{orderNoD}}</el-button>
                                </el-form>
                            </div>
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px;margin-top: -15px;" v-loading="txlloading">
                                    <template>
                                        <el-table :data="ctList" 
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column :label="$t('txl')" style="background-color:#550000">
                                                <el-table-column prop="phone" :label="$t('phone')">
                                                    <template slot-scope="scope">
                                                        <el-link type="primary" @click="dial(scope.row.phone,1)">
                                                            {{scope.row.phone}}
                                                        </el-link>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="name" :label="$t('name')"></el-table-column>
                                                <el-table-column prop="concern" :label="$t('guanxi')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern=='家庭'" type="primary">{{$t('txl1')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern=='普通'" type="info">{{$t('txl2')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="type" :label="$t('jjlxr')"></el-table-column>
                                                <el-table-column prop="callNumber" :label="$t('thcs')"></el-table-column>
                                                <el-table-column prop="callTime" :label="$t('thsj')"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="ctTotal" :current="ctPageNo" :pageSize="ctPageSize"
                                                @handleCurrentChange="ctCurrentchange" @handleSizeChange="ctHandchange"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <!-- <div class="orderdiv" style="margin-top: 8px;">
                                <div class="formbox" style="width:780px; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list1"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column label="催收记录" style="background-color:#550000">
                                                <el-table-column prop="clientName" label="姓名"></el-table-column>
                                                <el-table-column prop="tel" label="电话"></el-table-column>
                                                <el-table-column prop="callTime" label="拨打日期">
                                                    <template slot-scope="scope">
                                                        {{scope.row.callTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="concern" label="关系">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern==1" type="info">Padre/Madre</el-tag>
                                                        <el-tag v-if="scope.row.concern==2" type="info">Hermano(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==3" type="info">Amigo(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==4" type="info">Hijo(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==5" type="info">Abuelo(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==6" type="info">Tío(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==7" type="info">Primo(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==8" type="info">Sobrino(a)</el-tag>
                                                        <el-tag v-if="scope.row.concern==9" type="info">Otro</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="acceptorTime" label="承诺日期"></el-table-column>
                                                <el-table-column prop="className" label="分类"></el-table-column>
                                                <el-table-column prop="userName" label="员工"></el-table-column>
                                                <el-table-column prop="remark" label="备注"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="total1" :current="pageNo1" :pageSize="pageSize1"
                                                @handleCurrentChange="currentchange1" @handleSizeChange="handchange1"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div> -->
                        </el-tab-pane>
                        <!-- <el-tab-pane label="短信">
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px; margin-top: -15px;">
                                    <template>
                                        <el-table :data="smsList"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column label="短信" style="background-color:#550000">
                                                <el-table-column prop="phone" label="发送人"></el-table-column>
                                                <el-table-column prop="createTime" label="发送时间">
                                                    <template slot-scope="scope">
                                                        {{scope.row.createTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="content" label="发送人内容"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="smsTotal" :current="smsPageNo" :pageSize="smsPageSize"
                                                @handleCurrentChange="smsCurrentchange" @handleSizeChange="smsHandchange"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane> -->
                        <el-tab-pane :label="$t('gzjl')">
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list1"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column :label="$t('csjl')" style="background-color:#550000">
                                                <el-table-column prop="clientName" :label="$t('userName')"></el-table-column>
                                                <el-table-column prop="tel" :label="$t('phone')"></el-table-column>
                                                <el-table-column prop="callTime" :label="$t('cjrq')">
                                                    <template slot-scope="scope">
                                                        {{scope.row.callTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="concern" :label="$t('guanxi')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern==1" type="info">Orang Tua</el-tag>
                                                        <el-tag v-if="scope.row.concern==2" type="info">Saudara Kandung</el-tag>
                                                        <el-tag v-if="scope.row.concern==3" type="info">Teman</el-tag>
                                                        <el-tag v-if="scope.row.concern==4" type="info">Anak</el-tag>
                                                        <el-tag v-if="scope.row.concern==5" type="info">Kakek/Nenek</el-tag>
                                                        <el-tag v-if="scope.row.concern==6" type="info">Paman/Bibi</el-tag>
                                                        <el-tag v-if="scope.row.concern==7" type="info">Sepupu</el-tag>
                                                        <el-tag v-if="scope.row.concern==8" type="info">Keponakan</el-tag>
                                                        <el-tag v-if="scope.row.concern==9" type="info">Lainnya</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="acceptorTime" :label="$t('rlTime')"></el-table-column>
                                                <el-table-column prop="className" :label="$t('fl')"></el-table-column>
                                                <el-table-column prop="userName" :label="$t('yg')"></el-table-column>
                                                <el-table-column prop="remark" :label="$t('beizhu')"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="total1" :current="pageNo1" :pageSize="pageSize1"
                                                @handleCurrentChange="currentchange1" @handleSizeChange="handchange1"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane>
                        <!--<el-tab-pane label="审核记录">
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px;margin-top: -15px;">
                                    <el-table :data="loanList"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column label="借贷历史" style="background-color:#550000">
                                            <el-table-column prop="level" label="借款时间">
                                                <template slot-scope="scope">
                                                    {{scope.row.createTime|changedate}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="mchOrderNo" label="订单号"></el-table-column>
                                            <el-table-column prop="cuenta" label="银行卡号"></el-table-column>
                                            <el-table-column prop="cantidad" label="申请金额"></el-table-column>
                                            <el-table-column prop="days" label="申请期限"></el-table-column>
                                            <el-table-column prop="stats" label="订单状态"></el-table-column>
                                        </el-table-column>
                                    </el-table>
                                    <div class="page">
                                        <app-page :total="loanTotal" :current="loanPageNo" :pageSize="loanPageSize"
                                            @handleCurrentChange="loanCurrentchange" @handleSizeChange="loanHandchange">
                                        </app-page>
                                    </div>
                                </div>
                            </div>
                            <div class="orderdiv" style="margin-top: 8px;">
                                <div class="formbox" style="width:780px;margin-top: -15px;">
                                    <el-table :data="repList"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column label="还款记录" style="background-color:#550000">
                                            <el-table-column prop="phone" label="电话"></el-table-column>
                                            <el-table-column prop="orderNo" label="订单号"></el-table-column>
                                            <el-table-column prop="money" label="还款金额"></el-table-column>
                                            <el-table-column prop="level" label="创建时间">
                                                <template slot-scope="scope">
                                                    {{scope.row.createTime|changedate}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="orderNum" label="还款账号"></el-table-column>
                                            <el-table-column prop="typeName" label="还款方式"></el-table-column>
                                            <el-table-column prop="iden" label="还款类型">
                                                <template slot-scope="scope">
                                                    <el-tag v-if="scope.row.iden==1" type="primary" size="mini">还本金</el-tag>
                                                    <el-tag v-if="scope.row.iden==2" type="primary" size="mini">还展期</el-tag>
                                                    <el-tag v-if="scope.row.iden==3" type="primary" size="mini">还外部订单</el-tag>
                                                </template>
                                            </el-table-column>
                                        </el-table-column>
                                    </el-table>
                                    <div class="page">
                                        <app-page :total="repTotal" :current="repPageNo" :pageSize="repPageSize"
                                            @handleCurrentChange="repCurrentchange" @handleSizeChange="repHandchange">
                                        </app-page>
                                    </div>
                                </div>
                            </div>
                            <div class="orderdiv" style="margin-top: 8px;">
                                <template>
                                    <el-table :data="list"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column label="审核记录" style="background-color:#550000">
                                            <el-table-column prop="days" label="贷款天数"></el-table-column>
                                            <el-table-column prop="cantidad" label="应付金额"></el-table-column>
                                            <el-table-column prop="userName" label="姓名"></el-table-column>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </div>
                        </el-tab-pane>-->
                        <!-- <el-tab-pane :label="$t('releOrder')">
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list2"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column prop="body" :label="$t('pingt')"></el-table-column>
                                            <el-table-column prop="mchOrderNo" :label="$t('mchOrderNo')" width="188px"></el-table-column>
                                            <el-table-column prop="money" :label="$t('dkje')" width="88px"></el-table-column>
                                            <el-table-column prop="agingDetail" :label="$t('fqcs')" width="88px"></el-table-column>
                                            <el-table-column prop="expireTime" :label="$t('expireTime')" width="88px"></el-table-column>
                                            <el-table-column prop="stats" :label="$t('stats')"></el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="total2" :current="pageNo2" :pageSize="pageSize2"
                                                @handleCurrentChange="currentchange2" @handleSizeChange="handchange2"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('ssociatedTel')">
                            <div class="orderdiv">
                                <div class="formbox" style="width:780px; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list3"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column prop="phone" :label="$t('phone')" width="188px">
                                                <template slot-scope="scope">
                                                    <el-link type="primary" @click="dial(scope.row.phone, 0)">
                                                        {{scope.row.phone}}
                                                    </el-link>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="lastTime" :label="$t('p20')" width="188px"></el-table-column>
                                            <el-table-column prop="typeName" :label="$t('guanxi')"></el-table-column>
                                        </el-table>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane> -->
                    </el-tabs>
                </div>
            </div>
        </div>
        <pop-up :title="$t('tjcsjl')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" class="addCss">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="120px">
                    <el-form-item :label="$t('userName')" prop="clientName">
                        <el-input v-model="form.clientName" style="width: 300px;"/>
                    </el-form-item>
                    <el-form-item :label="$t('phone')" prop="tel">
                        <el-input v-model.number="form.tel" />
                    </el-form-item>
                    <el-form-item :label="$t('guanxi')" prop="concern">
                        <el-select size="small" v-model="form.concern" style="width:300px;" :placeholder="$t('qxzyggx')">
                            <el-option label="Orang Tua" :value="1"></el-option>
                            <el-option label="Saudara Kandung" :value='2'></el-option>
                            <el-option label="Teman" :value="3"></el-option>
                            <el-option label="Anak" :value="4"></el-option>
                            <el-option label="Kakek/Nenek" :value="5"></el-option>
                            <el-option label="Paman/Bibi" :value="6"></el-option>
                            <el-option label="Sepupu" :value="7"></el-option>
                            <el-option label="Keponakan" :value="8"></el-option>
                            <el-option label="Lainnya" :value="9"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('rlTime')" prop="acceptorTime">
                        <el-col :span="11">
                            <el-date-picker type="date" :placeholder="$t('xzTime')" v-model="form.acceptorTime" style="width: 190%;">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item :label="$t('fl')" prop="classId">
                        <el-select size="small" v-model="form.classId" filterable :placeholder="$t('qxzflmc')"  style="width:300px;">
                            <el-option :label="$t('qxzflmc')" :value="null"></el-option>
                            <el-option
                            v-for="item in classlist"
                            :key="item.id"
                            :label="item.classifyName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('beizhu')" prop="remark">
                        <el-input type="textarea" v-model="form.remark" style="width: 107%;"/>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null
                },
                rules: {
                    clientName:[{ required: true, message: this.$t('qsrxm'), trigger: 'blur' },],
                    tel:[{ required: true, message: this.$t('qsrdh'), trigger: 'blur' },],
                    concern:[{ required: true, message: this.$t('qxzyggx'), trigger: 'blur' },],
                    acceptorTime:[{ required: true, message: this.$t('qxzrq'), trigger: 'blur' },],
                    classId:[{ required: true, message: this.$t('qxzflmc'), trigger: 'blur' },],
                    //remark:[{ required: true, message: this.$t('qsrbz'), trigger: 'blur' },],
                },
                orderForm:{
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    upProductName:null,
                    stats: null
                },
                contactform:{
                    onePhone:null,
                    oneName:null,
                    oneType:null,
                    twoPhone:null,
                    twoName:null,
                    twoType:null,
                    threePhone:null,
                    threeName:null,
                    threeType:null,
                    foruPhone:null,
                    foruName:null,
                    foruType:null,
                },
                homeTotal:{
                    callNum: 0,
                    recall: 0,
                    recallRate: 0,
                    callMoney: 0,
                    recallMoney: 0
                },
                searchform: {
                    blurry: "",
                },
                searchform1: {
                    phone: "",
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                txlloading: false,
                loanLoading:false,
                homeLoading:false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                searchform1:{},
                total: 0,
                pageNo: 1,
                pageSize: 10,
                loanTotal: 0,
                loanPageNo: 1,
                loanPageSize: 5,
                ctTotal: 0,
                ctPageNo: 1,
                ctPageSize: 10,
                total1: 0,
                pageNo1: 1,
                pageSize1: 10,
                total2: 0,
                pageNo2: 1,
                pageSize2: 10,
                smsTotal: 0,
                smsPageNo: 1,
                smsPageSize: 5,
                repTotal: 0,
                repPageNo: 1,
                repPageSize: 10,
                keyword: '',
                user:null,
                rolelist: [],
                status: null,
                classlist: [],
                loanList:[],
                ctList:[],
                list1: [],
                list2: [],
                list3: [],
                smsList:[],
                repList:[],
                currentRow: null,
                orderDeId:null,
                relePhone:null,
                principallist1:[],
                accountlist: [],
                cardFirst: null,
                cardSecond: null,
                orderNoD:null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getclass()
            this.getHomeTotal()
            this.getprincipal1()
            this.getaccount()
        },
        methods: {
            
            dial(row, row1) {
                _api.get(apiurl.dial, {
                    phone : row,
                    type : row1,
                    nation : localStorage.getItem("nation"),
                }).then(res => {
                    alert(res.message);
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            openadd(row) {
                this.orderDeId = row.id;
                this.showadd = true
                this.form = {
                    id: null,
                    clientName: null,
                    tel: null,
                    callTime: null,
                    concern: null,
                    acceptorTime: null,
                    className: null,
                    remark: null,
                    userName: null,
                    nation: localStorage.getItem("nation"),
                    orderId: row.id
                }
            },
            getaccount() {
                _api.get(apiurl.accountBook, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.accountlist = res.data
                })
            },
            handleCurrentChange(val) {
                this.currentRow = val.userId;
                this.orderDeId = val.id;
                this.relePhone = val.phone;
                this.getDetail();
                this.getOrderDetail();
                this.getContactDetail();
                this.getLoanList();
                this.getCtList();
                this.getList1();
                this.getSmsList();
                this.getRepList();
                this.getList2();
                this.getList3();
            },
            getprincipal1() {
                _api.get(apiurl.users, {
                    roleId: 3,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.principallist1 = res.content
                })
            },
            getclass() {
                _api.get(apiurl.classifyAll, {
                }).then(res => {
                    this.classlist = res.data
                })
            },
            getconfirm() {
                if (this.form.clientName == null || this.form.clientName=="") {
                    this.$message.error(this.$t('qsrxm'))
                    return
                }
                if (this.form.tel == null || this.form.tel=="") {
                    this.$message.error(this.$t('qsrdh'))
                    return
                }
                if (this.form.concern == null || this.form.concern=="") {
                    this.$message.error(this.$t('qxzyggx'))
                    return
                }
                if (this.form.acceptorTime == null || this.form.acceptorTime=="") {
                    this.$message.error(this.$t('qxzrq'))
                    return
                }
                if (this.form.classId == null || this.form.classId=="") {
                    this.$message.error(this.$t('qxzflmc'))
                    return
                }
                if (this.form.orderId == null || this.form.orderId=="") {
                    this.$message.error(this.$t('qxzdd'))
                    return
                }
                _api.post(apiurl.callInfo, this.form)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('addSuccess')
                    })
                    this.getList()
                    this.showadd = false
                    this.form = {
                        id: null,
                        clientName: null,
                        tel: null,
                        callTime: null,
                        concern: null,
                        acceptorTime: null,
                        className: null,
                        remark: null,
                        userName: null,
                        orderId: this.orderDeId
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            cf() {
                this.dial(this.cardFirst,0)
            },
            cs() {
                this.dial(this.cardSecond,0)
            },
            getList() {
                this.loading = true
                _api.get(apiurl.mycallorder, {
                    page: this.pageNo,
                    size: this.pageSize,
                    phone: this.searchform.phone,
                    mchOrderNo: this.searchform.mchOrderNo,
                    stats: this.searchform.stats,
                    createTime: this.value1,
                    status:this.searchform.status,
                    nation:localStorage.getItem("nation"),
                    principalId:this.searchform.principalId,
                    accountId:this.searchform.accountId,
                    type: this.searchform.statusValue,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            getCtList() {
                this.txlloading = true
                _api.get(apiurl.userContact, {
                    page: this.ctPageNo,
                    size: this.ctPageSize,
                    nation:localStorage.getItem("nation"),
                    blurry:this.searchform1.phone,
                    userId: this.currentRow
                }).then(res => {
                    this.ctList = res.data.data
                    this.ctTotal = res.data.totalCount
                    this.txlloading = false
                })
            },
            getLoanList() {
                this.loanLoading = true
                _api.get(apiurl.myOrderRecord, {
                    page: this.loanPageNo,
                    size: this.loanPageSize,
                    nation:localStorage.getItem("nation"),
                    userId: this.currentRow
                }).then(res => {
                    this.loanLoading = false
                    this.loanList = res.data.list
                    this.loanTotal = res.data.total
                })
            },
            getOrderDetail(){
                _api.get(apiurl.orderDetail,{
                    nation:localStorage.getItem("nation"),
                    orderId:this.orderDeId
                }).then(res=>{
                    this.orderForm.phone=res.data.phone
                    this.orderForm.mchOrderNo=res.data.mchOrderNo
                    this.orderForm.email=res.data.email
                    this.orderForm.userName=res.data.userName
                    this.orderForm.cantidad=res.data.cantidad
                    this.orderForm.days=res.data.days
                    this.orderForm.overdueDay=res.data.overdueDay
                    this.orderForm.expireTime=res.data.expireTime
                    this.orderForm.createTime=res.data.createTime
                    this.orderForm.exclusiveLinks=res.data.exclusiveLinks
                    this.orderForm.exclusiveLinks=res.data.exclusiveLinks
                    this.orderForm.stats=res.data.stats
                    this.orderForm.outMoney=res.data.outMoney
                    this.orderForm.upProductName=res.data.upProductName
                    this.cardFirst=res.data.cardFirst
                    this.cardSecond=res.data.cardSecond
                    this.orderNoD = res.data.mchOrderNo
                })
            },
            getContactDetail(){
                _api.get(apiurl.contactInfo,{
                    userId:this.currentRow
                }).then(res=>{
                    this.contactform.onePhone=res.data.onePhone
                    this.contactform.oneName=res.data.oneName
                    this.contactform.oneType=res.data.oneType
                    this.contactform.twoPhone=res.data.twoPhone
                    this.contactform.twoName=res.data.twoName
                    this.contactform.twoType=res.data.twoType

                    this.contactform.threePhone=res.data.threePhone
                    this.contactform.threeName=res.data.threeName
                    this.contactform.threeType=res.data.threeType
                    this.contactform.foruPhone=res.data.foruPhone
                    this.contactform.foruName=res.data.foruName
                    this.contactform.foruType=res.data.foruType
                })
            },
            getDetail(){
                _api.get(apiurl.userInfo,{userId:this.currentRow}).then(res=>{
                    this.form.birthday=res.data.birthday
                    this.form.addressAll=res.data.addressAll
                    this.form.gender=res.data.gender
                    this.form.fatherLastName=res.data.fatherLastName
                    this.form.motherLastName=res.data.motherLastName
                    this.form.postalCode=res.data.postalCode
                    this.form.fullName=res.data.fullName
                    this.form.idNumber=res.data.idNumber
                    this.form.district=res.data.district
                    this.form.email=res.data.email
                    this.form.educationName=res.data.educationName
                    this.form.employmentName=res.data.employmentName
                    this.form.comoanyName=res.data.comoanyName
                    this.form.comoanyPhone=res.data.comoanyPhone
                    this.form.workingYearName=res.data.workingYearName
                    this.form.monthlySalaryName=res.data.monthlySalaryName
                    this.form.workingDaysName=res.data.workingDaysName
                    this.form.idCardPositive=res.data.idCardPositive
                    this.form.idCardReverse=res.data.idCardReverse
                    this.form.faceUrl=res.data.faceUrl
                })
            },
            getHomeTotal(){
                this.homeLoading = true
                _api.get(apiurl.callTotal,{
                    nation:localStorage.getItem("nation"),
                }).then(res=>{
                    this.homeLoading = false
                    this.homeTotal.callNum=res.data.callNum
                    this.homeTotal.recall=res.data.recall
                    this.homeTotal.recallRate=res.data.recallRate
                    this.homeTotal.callMoney= this.formatInteres(res.data.callMoney)
                    this.homeTotal.recallMoney=this.formatInteres(res.data.recallMoney)
                })
            },

            formatInteres(value) {
                // 将值转换为数字，若转换失败则返回原值
                const number = Number(value);
                return isNaN(number) ? value : number.toLocaleString('en-US');
            },
            getList1() {
                _api.get(apiurl.callInfo, {
                    page: this.pageNo1,
                    size: this.pageSize1,
                    orderId: this.orderDeId
                }).then(res => {
                    this.list1 = res.data.list
                    this.total1 = res.data.total
                })
            },
            getList2() {
                _api.get(apiurl.relevanceOrder, {
                    page: this.pageNo2,
                    size: this.pageSize2,
                    phone: this.relePhone,
                    orderId: this.orderDeId
                }).then(res => {
                    this.list2 = res.data.data
                    this.total2 = res.data.totalCount
                })
            },
            getList3() {
                _api.get(apiurl.associatedTel, {
                    orderId: this.orderDeId
                }).then(res => {
                    this.list3 = res.data
                })
            },
            getSmsList(){
                _api.get(apiurl.sysNews, {
                    page: this.smsPageNo,
                    size: this.smsPageSize,
                    userId:this.currentRow
                }).then(res => {
                    this.smsList = res.data.list
                    this.smsTotal = res.data.total
                })
            },
            getRepList(){
                _api.get(apiurl.repayment, {
                    page: this.repPageNo,
                    size: this.repPageSize,
                    userId:this.currentRow
                }).then(res => {
                    this.repList = res.data.list
                    this.repTotal = res.data.total
                })
            },
            copyContent(row) {
                navigator.clipboard.writeText(row)
                alert("复制成功")
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            txlonSubmit() {
                this.ctPageNo = 1
                this.getCtList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            loanHandchange(data) { //分页Size变化
                this.loanPageSize = data
                this.loanPageNo = 1
                this.getLoanList()
            },
            loanCurrentchange(data) { //当前页变化
                this.loanPageNo = data
                this.getLoanList()
            },
            ctHandchange(data) { //分页Size变化
                this.ctPageSize = data
                this.ctPageNo = 1
                this.getCtList()
            },
            ctCurrentchange(data) { //当前页变化
                this.ctPageNo = data
                this.getCtList()
            },
            handchange1(data) { //分页Size变化
                this.pageSize1 = data
                this.pageNo1 = 1
                this.getList1()
            },
            currentchange1(data) { //当前页变化
                this.pageNo1 = data
                this.getList1()
            },
            handchange2(data) { //分页Size变化
                this.pageSize2 = data
                this.pageNo2 = 1
                this.getList2()
            },
            currentchange2(data) { //当前页变化
                this.pageNo2 = data
                this.getList2()
            },
            smsHandchange(data) { //分页Size变化
                this.smsPageSize = data
                this.smsPageNo = 1
                this.getSmsList()
            },
            smsCurrentchange(data) { //当前页变化
                this.smsPageNo = data
                this.getSmsList()
            },
            repHandchange(data) { //分页Size变化
                this.repPageSize = data
                this.repPageNo = 1
                this.getRepList()
            },
            repCurrentchange(data) { //当前页变化
                this.repPageNo = data
                this.getRepList()
            },
        }
    }
</script>
<style scoped>
    
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .orderdiv{
        display: flex;
        border-style: ridge;
        border-bottom: 1px solid #EBEEF5;
    }

    .listleft {
        width: 50%;
        margin-left: 0.5%;
    }

    body .el-table th.gutter{
        display: table-cell!important;
    }

    .listright {
        width: 50%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }
    .formbox{ padding:15px 0; margin-top: 10px;}

    .listrighttop span {
        float: right;
    }
    .toptj{ display: flex; margin:15px 0;}
    .tjitem{ 
        flex: 1; 
        background: #ffffff; 
        cursor: pointer; 
        border: #ebedf0 solid 1px; 
        height: 60px; 
        margin-right: 10px;
        padding: 8px 12px;
        text-align: center;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>